export const useDateFormatter = () => {
  const formatDate = (value: string | Date) => {
    if (!value) return "-";

    const date = typeof value === "string" ? new Date(value) : value;
    if (isNaN(date.getTime())) return "-";

    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return (
      <span className="text-[13px] text-[var(--secondary-text-color)]">
        {`${month} ${day}, ${year}, ${hours}:${minutes} ${ampm}`}
      </span>
    );
  };

  return { formatDate };
};
